// Components==============
import Button from 'components/UI/Button';
import { TextInput } from 'components/UI/Form/Input';
import changeDocName from 'actions/group/update';
import Modal from 'components/UI/Modal';
import React from 'react';
import './Modals.module.scss';
import { useDispatch } from 'react-redux';
import { useFormValues } from 'utilities/useFormValues';
// =========================

export default function ChangeNameModal({ setModalIsOpen, doc }) {
    const dispatch = useDispatch();

    const { formValues, handleChange } = useFormValues({
        name: doc?.name || '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        const conditionalItems = doc?.parent_id
            ? { groupId: doc.id, updateGroup: true }
            : { fileId: doc.id, updateFile: true };

        return dispatch(
            changeDocName({
                ...conditionalItems,
                name: formValues.name,
            })
        ).then(() => setModalIsOpen(false));
    }

    return (
        <Modal closeModal={() => setModalIsOpen(false)}>
            <div styleName="content">
                <h3>Naam wijzigen</h3>
                <p>Voer de nieuwe naam in</p>

                <form onSubmit={handleSubmit}>
                    <div>
                        <TextInput
                            label="Naam"
                            onChange={handleChange}
                            name="name"
                            value={formValues.name}
                        />
                    </div>
                    <div>
                        <Button>Opslaan</Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
